import {PosTerminalDeviceContainerModel} from './../../../../../../models/aggregates/erp/pos/pos-terminal-device-container.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa, Pagination } from '../../shared';




@Injectable({
  providedIn: 'root'
})
export class PosTerminalService extends BaseApiTemplateService<PosTerminalDeviceContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-terminal-devices';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'pos-terminal-devices';
    this.httpClient = http;
  }

  getPosTerminalDevicePublic(apiVisa: ApiVisa, pagination: Pagination) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path+"/public";
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get(UrlByCriteria, this.getHttpHeader(apiVisa) );
  }

}
